import React from 'react'
import moment from 'moment';
import {  getFileFromType } from 'Helpers/Documents';
import ReactHtmlParser from 'react-html-parser';
import { getColorForName } from 'Helpers/colorPalette';

function addHtmlTag(str) {
  return `<small>${ str }</small>`;
}

export default ({
  timestamp,
  contactName = '',
  filename,
  fileUrl,
  publisherId,
  message_type,
  contactNumber = '[]',
  contactDetails = {},
  ...props
}) => {
  let htmlContent = ''
  try {
    htmlContent = contactNumber.slice(1, -1).split(',').map(addHtmlTag).join('');
  } catch (error) {
    htmlContent = contactNumber
  }
 
  const { feedbackDetails: { reporterMobile,type },name } = props
  const isReporter = publisherId.includes(reporterMobile);
  const placeholder = getFileFromType(null, null, message_type);
  const nameColor = getColorForName(name);

  return (
    <div className={ `${ isReporter ? 'repoter' : 'repoted' }` }>
      <div className={ `attachment-block contact` }>
         {type === 'groupchat' && (
            <div
              className='report-user-name'
              style={ { color: nameColor } }
            >
              { name }
            </div>
          )}
        <div className='attachment'>
          <img alt="file" src = { placeholder } className='attachment-img' />
          <span className='attachment-name'>{ contactDetails.contact.name } {ReactHtmlParser(htmlContent)} </span>
          <span className='attachment-time'>{ moment(parseInt(timestamp)).format('h:mm A') } </span>
        </div>
      </div>
    </div>
  )
}
